// Ubicación en el repo: src/lib/brands.js
// Marcas de producto del catálogo (migración 0046, Fase A del módulo de
// Inventario/Contabilidad — ver plan-inventario-y-contabilidad.md,
// 24-ago-2026). Reemplaza el texto libre `catalog.brand` por una entidad
// administrable — mismo criterio que categories.js/branches.js.
import { supabase } from './supabaseClient';

export async function listActiveBrands() {
  const { data, error } = await supabase
    .from('brands')
    .select('id, name')
    .is('deleted_at', null)
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function listAllBrandsForAdmin() {
  const { data, error } = await supabase
    .from('brands')
    .select('id, name, deleted_at')
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

// Mayúsculas a propósito — mismo criterio que el catálogo antes de esta
// fase (CatalogFormModal.jsx forzaba `brand.trim().toUpperCase()`); se
// mantiene acá para que las marcas ya existentes (migradas desde ese
// texto, todas en mayúsculas) y las nuevas queden consistentes.
export async function createBrand(name) {
  const { data, error } = await supabase
    .from('brands')
    .insert({ name: name.trim().toUpperCase() })
    .select('id')
    .single();
  if (error) throw error;
  return data.id;
}

export async function updateBrand(id, name) {
  const { error } = await supabase.from('brands').update({ name: name.trim().toUpperCase() }).eq('id', id);
  if (error) throw error;
}

export async function softDeleteBrand(id, actorId) {
  const { error } = await supabase
    .from('brands')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}

export async function restoreBrand(id) {
  const { error } = await supabase.from('brands').update({ deleted_at: null, deleted_by: null }).eq('id', id);
  if (error) throw error;
}
